import { Link } from "react-router-dom";
import Layout from "../components/Layout";

const NotFound = () => {
  return (
    <Layout>
      <section className="azzir-not-found">
        <div className="container">
          <div className="azzir-not-found__inner">
            <div className="azzir-not-found__badge" aria-hidden="true">
              <svg
                width="40"
                height="40"
                viewBox="0 0 64 64"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <circle cx="28" cy="28" r="14" />
                <line x1="38" y1="38" x2="52" y2="52" strokeWidth="3.2" />
                <line x1="22" y1="28" x2="34" y2="28" />
              </svg>
            </div>

            <p className="azzir-not-found__eyebrow">Page not found</p>
            <h1 className="azzir-not-found__title">No Content Available</h1>
            <span className="azzir-not-found__rule" aria-hidden="true" />
            <p className="azzir-not-found__message">
              This link is broken or the page no longer exists.
            </p>

            <Link to="/" className="azzir-not-found__btn">
              Back to Home
            </Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
